<template>
  <div class="member-profile-info d-sm-flex gap-20">
    <div class="d-flex flex-column align-items-center mb-20 gap-10">
      <AppAvatar
        :avatar="user.avatar"
        size="70"
      />
      <div class="sm-show small text-lighter text-center">
        Joined<br /><span class="started">{{ membership.created_on }}</span>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center align-items-sm-start flex-1">
      <div v-if="membership.job_title">
        <div class="d-inline-flex break-word align-items-center mb-10">
          <i class="hi hi-16 hi-briefcase text-lighter mr-10" />
          <span class="job-title">{{ membership.job_title }}</span>
        </div>
      </div>
      <div v-if="user.email">
        <div class="d-inline-flex break-word align-items-center mb-10">
          <i class="hi hi-16 hi-mail text-lighter mr-10" />
          <span class="user-email">{{ initialEmail }}</span>
          <div
            class="d-flex"
            v-html="editLinkComponent"
          />
        </div>
      </div>
      <div v-if="formattedTimeZone">
        <div class="d-inline-flex break-word align-items-center mb-10">
          <i class="hi hi-16 hi-globe text-lighter mr-10" />
          <span class="time-zone">{{ formattedTimeZone }}</span>
          <div
            class="d-flex"
            v-html="editLinkComponent"
          />
        </div>
      </div>
      <div
        v-if="membership.last_activity_at"
        class="d-inline-flex break-word align-items-center mb-10"
      >
        <i class="last-tracked-icon mr-10" />
        <span
          v-tooltip="true"
          class="a-tooltip last-tracked-time"
          data-placement="top"
          data-html="true"
          :title="lastTrackedTimeTooltip"
        >
          Last tracked time {{ lastTrackedTimeText }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';

import dayjs from 'dayjs';
import dayjsRelativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(dayjsRelativeTime);

export default {
  name: 'MemberProfileInfo',
  data: () => ({
    initialEmail: '',
  }),
  computed: {
    ...mapState(['membership']),
    ...mapState({
      currentUser: 'current_user',
      editUserUrl: 'edit_user_url',
      membersUrl: 'members_url',
      user: (state) => state.membership.user,
    }),
    formattedTimeZone() {
      return this.user.time_zone.formatted_timezone;
    },
    lastTrackedTimeText() {
      const lastActivity = dayjs(this.membership.last_activity_at).fromNow(true);

      return `${lastActivity} ago`;
    },
    lastTrackedTimeTooltip() {
      let tooltip = dayjs(this.membership.last_activity_at).format('ddd, MMM D, YYYY h:mm a');

      if (this.membership.last_activity_project) {
        tooltip += `<br /> ${HubstaffUtils.escapeHTML(this.membership.last_activity_project)}`;
        if (this.membership.last_activity_task) {
          tooltip += ` / ${HubstaffUtils.escapeHTML(this.membership.last_activity_task)}`;
        }
      }

      return tooltip;
    },
    editUserHref() {
      return this.editUserUrl.replace('__USER_ID__', this.user.id);
    },
    isCurrentUser() {
      return this.currentUser.id === this.user.id;
    },
    editLinkComponent() {
      if (this.isCurrentUser) {
        return `<a class="d-flex text-lighter ml-10 a-tooltip" href="${this.editUserHref}" data-placement="right" title="Open Hubstaff Account"><i class="hi hi-12 hi-external"></i></a>`;
      }

      if (!this.membership.time_zone_editable) {
        return `<i class="hi hi-12 hi-info-filled a-tooltip text-lighter ml-10" data-placement="right" title="This Hubstaff account data can only be changed by the member"></i>`;
      }

      return '';
    },
  },
  mounted() {
    this.initialEmail = this.user.email;
  },
};
</script>
